import React, { useCallback } from "react";
import { GlobalBox } from 'components/Box/GlobalBox'
import { useSelector, useDispatch } from "react-redux";
import TodayIcon from '@mui/icons-material/Today';
import { TableInputs } from "components/CardTable/TableInputs"
import { newDate } from "helpers/dateTools";
import { useSearch } from "hooks/useSearch";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportResumeDayFilters, getReportResumeDayAction } from "redux/actions/Reports/reportResumeDay/reportResumeDayActions";

export const ReportResumeDayView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { date, station } = useSelector(({ reportResumeDay }) => reportResumeDay);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault()
    if (!date || !station?.id) {
      setSnackbar("Faltan datos requeridos.", 'warning');
      return;
    }
    dispatch(getReportResumeDayAction({ date, station, isPdf }))
  }, [date, station]);

  const handleSubmitExcel = useCallback((e) => handleSubmit(e, false), [handleSubmit]);

  return (
    <GlobalBox title="Reporte Resumen Día" icon={<TodayIcon />} >
      {isLoadingComp?.loadingReportResumeDay ? <LoadingComponent /> :
        <TableInputs
          reducer="reportResumeDay"
          date
          stations
          maxDate={newDate()}
          dispatchAction={setReportResumeDayFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={handleSubmitExcel}
        />
      }
    </GlobalBox>
  );
};
